import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import AuthService from 'services/AuthService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null
}

export const signIn = createAsyncThunk('auth/login',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		const response = await AuthService.login({email, password})

		if(response.user){
			const token = response.user.accessToken;
			localStorage.setItem(AUTH_TOKEN, token);
			return token;
		}else{
			const errorMessage = response.message || 'Erro'
			
			if(errorMessage.includes('auth/invalid-login-credentials'))
				return rejectWithValue('Email ou senha incorretos!')
			else if (errorMessage.includes('auth/user-disabled'))
				return rejectWithValue('Usuário desativado!')
			else
				return rejectWithValue(errorMessage)
		}

	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Erro')
	}
})

export const signUp = createAsyncThunk('auth/register',async (data, { rejectWithValue }) => {
	const { email, password, name } = data
	try {
		const response = await AuthService.register({email, password, name})
		
		if(response.user){
			const token = response.user.accessToken;
			localStorage.setItem(AUTH_TOKEN, token);
			return token;
		}else{
			const errorMessage = response.message || 'Erro'
			if(errorMessage.includes('auth/email-already-in-use'))
				return rejectWithValue('Este email ja existe!')
			else
				return rejectWithValue(errorMessage)
		}

	} catch (e) {
		console.log(e)
		return rejectWithValue(e.response?.data?.message || 'Erro')
	}
})

export const signOut = createAsyncThunk('auth/logout',async () => {
	const response = await AuthService.logout()
	localStorage.removeItem(AUTH_TOKEN);
    return response.data
})

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const { 
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer